<script setup>
import { ref, nextTick, onMounted } from 'vue';

const emit = defineEmits(['send']);
const message = ref('');
const textareaRef = ref(null);

const adjustHeight = () => {
  if (!textareaRef.value) return;

  // Reset height to auto to get the correct scrollHeight
  textareaRef.value.style.height = 'auto';
  // Set the height to the scrollHeight
  textareaRef.value.style.height = `${textareaRef.value.scrollHeight}px`;
};

const sendMessage = () => {
  if (message.value.trim()) {
    emit('send', message.value);
    message.value = '';
    // Reset textarea height after sending
    nextTick(() => {
      adjustHeight();
    });
  }
};

const handleInput = () => {
  nextTick(adjustHeight);
};

const handleEnterKey = event => {
  if (event.isComposing) return;
  event.preventDefault();
  sendMessage();
};

onMounted(() => {
  nextTick(adjustHeight);
});
</script>

<template>
  <form
    class="flex items-end gap-2 p-1.5 ltr:pl-4 rtl:pr-4 rounded-2xl border border-n-strong bg-n-alpha-3 backdrop-blur-lg shadow-sm focus-within:border-n-violet-9 focus-within:ring-2 focus-within:ring-n-violet-9/30 transition-colors"
    @submit.prevent="sendMessage"
  >
    <textarea
      ref="textareaRef"
      v-model="message"
      :placeholder="$t('CAPTAIN.COPILOT.SEND_MESSAGE')"
      class="flex-1 reset-base bg-transparent py-2 text-sm border-0 focus:outline-0 focus:outline-none focus:ring-0 resize-none overflow-hidden max-h-[200px] mb-0 text-n-slate-12"
      rows="1"
      @input="handleInput"
      @keydown.enter.exact="handleEnterKey"
    />
    <button
      class="size-8 mb-0.5 rounded-full flex-shrink-0 flex items-center justify-center text-white bg-gradient-to-br from-n-violet-9 to-n-iris-9 hover:brightness-110 transition-[filter]"
      type="submit"
    >
      <i class="i-ph-arrow-up" />
    </button>
  </form>
</template>
